import colors from '../../tokens/colors';
import colorTokens from './colorTokens';
import componentColorTokens from './componentColorTokens';
import borders from '../shared/borders';
import typography from '../shared/typography';
import spacing from '../shared/spacing';
import radiusTokens from './radiusTokens';
import { getTypography } from './typography';
const createLightTheme = (customTokens) => {
    const updatedTokens = Object.assign(Object.assign({}, colorTokens), customTokens.colors);
    const bordersTokens = Object.assign(Object.assign({}, borders), customTokens.borders);
    const typographyTokens = Object.assign(Object.assign({}, typography), customTokens.typography);
    const theme = {
        colors: Object.assign(Object.assign(Object.assign({}, colors), updatedTokens), componentColorTokens(updatedTokens)),
        borders: Object.assign(Object.assign({}, radiusTokens(bordersTokens)), bordersTokens),
        typography: Object.assign(Object.assign({}, typographyTokens), getTypography(typographyTokens)),
        spacing,
    };
    // TODO: replace with deep copy
    return Object.assign({}, theme);
};
export default createLightTheme;
